export default {
  importData: 'Import data',
  importDataTitle: 'Import Data',
  copyInstructions: 'Copy this text to your spreadsheet, modify it, and then copy it back:',
  modelDataLabel: 'Model Data',
  cancel: 'Cancel',
  import: 'Import',
  set: 'Set',
  period: 'Period',
  onlyDigitsAllowed: 'Only digits allowed',
  wrongNumberOfRows: 'Wrong number of rows',
  wrongNumberOfColumns: 'Wrong number of columns',
  invalidHeaderRow: 'Invalid header row',
  invalidPeriodColumn: 'Invalid Period column',
  onlyWholeNumbersAllowed: 'Only whole numbers are allowed as values',
  errorShouldBeDate: 'Error: should be a date'
}
